import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUserToken } from '../redux/features/user/userSelectors';
import { useGetRequestQuery } from '../redux/services/requests/requestsApi';
import { useGetRealtiesByIdsQuery } from '../redux/services/search/searchApi';

export const useRequestLikes = (overrideRequestId = null) => {
  const [searchParams] = useSearchParams();
  const requestIdParam = overrideRequestId ?? searchParams.get('requestId');
  const requestId = requestIdParam ? Number(requestIdParam) : null;
  const userToken = useSelector(selectUserToken);

  const {
    data: searchRequest,
    isLoading: isRequestLoading,
    isFetching,
  } = useGetRequestQuery(
    { token: userToken, id: requestId },
    { skip: !requestId }
  );

  const activeRequest = requestId ? searchRequest : null;

  const likedIds = useMemo(() => activeRequest?.likes?.like ?? [], [activeRequest?.likes]);
  const dislikedIds = useMemo(() => activeRequest?.likes?.dislike ?? [], [activeRequest?.likes]);

  const { data: allLikeDislikeRealtiesData } = useGetRealtiesByIdsQuery(
    { token: userToken, ids: [...likedIds, ...dislikedIds] },
    { skip: !activeRequest || (likedIds.length + dislikedIds.length) === 0 }
  );

  const likedRealties = useMemo(
    () => allLikeDislikeRealtiesData?.realties?.filter(r => likedIds.includes(r.id)) ?? [],
    [allLikeDislikeRealtiesData?.realties, likedIds]
  );

  const dislikedRealties = useMemo(
    () => allLikeDislikeRealtiesData?.realties?.filter(r => dislikedIds.includes(r.id)) ?? [],
    [allLikeDislikeRealtiesData?.realties, dislikedIds]
  );

  return {
    searchRequest: activeRequest ?? null,
    likedRealties,
    dislikedRealties,
    likeCount: likedRealties.length,
    dislikeCount: dislikedRealties.length,
    isFetching,
    isRequestLoading,
  };
};
